import { computed } from 'vue';
import { useStore, useMapGetter } from 'dashboard/composables/store';

export const useAccountTimezone = () => {
  const store = useStore();
  const getCurrentAccountId = useMapGetter('getCurrentAccountId');
  const getAccount = useMapGetter('accounts/getAccount');

  const accountTimezone = computed(() => {
    const accountId = getCurrentAccountId.value;
    if (!accountId) return null;

    const account = getAccount.value(accountId);
    return account?.timezone || null;
  });

  return {
    accountTimezone,
  };
};
